// css =>
import "../../BaseStructure.css";
import Styled from "./OrderShow.module.css";

// componenets =>
import Header from "../../Components/header/header.comp";
import MenuBar from "../../Components/menuBar/menuBar.comp";
import OrderBox from "../../Components/orderBox/orderBox.comp";
import SpinnerBar from "../../Components/spinnerBar/spinnerBar.comp";
import HeaderTittle from "../../Components/headerTittle/headerTittle.comp";
import LocationShow from "../../Components/locationShow/locationShow.comp";
import FirstMenuBar from "../../Components/firstMenuBar/firstMenuBar.comp";
import MobileMenuBar from "../../Components/mobileMenuBar/mobileMenuBar.comp";
import PagePagination from "../../Components/pagePagination/pagePagination.comp";

// react =>
import { useState, useEffect, JSX } from "react";
import { useNavigate } from "react-router-dom";

// API =>
import backEnd from "../../services/Api";

// utils =>
import { useUserStore } from "../../hooks/useUserStore";
import { formatDate, formatTime } from "../../utils/ChangeDateTimeIsoFormat";

// type =>
import { PaginatedOrderResponse } from "./OrderShowType";

// context =>
import { useMessage } from "../../Contexts/MessageBoxContext";

function OrderShow() {

    const pageSize = 20;
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [numberOfOrders, setNumberOfOrders] = useState<number>(0);

    const navigate = useNavigate();
    const { showMessage } = useMessage();

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [ordersList, setOrdersList] = useState<PaginatedOrderResponse | null>(null);

    useEffect(() => {
        document.title = "سفارشات | وضعیت سفارش";

        setIsLoading(true);
        backEnd.get(`orders/get-order?orderer__id=${ useUserStore.getState().user?.id }&page=${ currentPage }`).then(( result ) => {
            setOrdersList(result.data);
            setNumberOfOrders(result.data.count);

            setIsLoading(false);
        }).catch(( error ) => {
            let errorMessage = "خطای غیرمنتظره‌ای رخ داد.";

            if (error.response) {
                const status = error.response.status;

                switch (status) {
                    case 400:
                        errorMessage = "درخواست ارسال شده نامعتبر است.";
                        break;

                    case 401:
                    case 403:
                        useUserStore.getState().setUser(null);
                        localStorage.removeItem("user-storage");

                        errorMessage = "لطفاً ابتدا وارد حساب کاربری خود شوید یا ثبت نام کنید!";
                        navigate("/sign-in");
                        break;

                    case 404:
                        errorMessage = "سفارشی برای شما پیدا نشد.";
                        break;

                    case 429:
                        errorMessage = "تعداد درخواست‌ها زیاد است. لطفاً کمی بعد دوباره تلاش کنید.";
                        break;

                    case 500:
                        errorMessage = "خطایی در سرور رخ داده است. لطفاً بعداً تلاش کنید.";
                        break;

                    case 503:
                        errorMessage = "سرور موقتاً در دسترس نیست.";
                        break;

                    default:
                        errorMessage = "خطایی رخ داده است. لطفاً دوباره تلاش کنید.";
                }
            } else if (error.request) {
                errorMessage = "اتصال به سرور برقرار نشد. اینترنت خود را بررسی کنید.";
            } else {
                errorMessage = "مشکلی در ارسال درخواست به وجود آمد.";
            }

            setIsLoading(false);
            showMessage("error", errorMessage);
        })
    }, [currentPage]);

    return(
        <>
            <Header />
            <MobileMenuBar key={ 0 } isAuthenticated />
            <LocationShow key={ 1 } pathName="حساب کاربری من" />
            <FirstMenuBar key={ 2 } />

            <HeaderTittle key={ 3 } headerTittleList={["جزءیات بسته", "تاریخ خرید", "ساعت خرید", "وضعیت پرداخت", "وضعیت بسته", "پیگیری", "کد پیگیری"]} />

            {
                isLoading ? (
                    <div className="row">
                        <div className="col-12 SpinnerBarFrame">
                            <SpinnerBar />
                        </div>
                    </div>
                ) : ordersList?.count === 0 ? (
                    <p className="EmptyText">شما هیچ سفارشی ندارید!</p>
                ) : (
                    ordersList?.results.map(( order ) => {
                        return <OrderBox
                            key={ order.id }
                            orderCode={ order.id }
                            orderDate={ formatDate(order.created_at) }
                            orderTime={ formatTime(order.created_at) }
                            orderPaymentStatus="پرداخت شده"
                            orderStatus={ order.order_status_display }
                            orderKey={ order.id }
                            items={ order.items }
                        />
                    })
                )
            }

            <br /><br /><br />

            <div className="row" id={Styled.PagePaginationFrame}>
                <PagePagination
                    currentPage={ currentPage }
                    totalCount={ numberOfOrders }
                    pageSize={ pageSize }
                    onPageChange={(page) => setCurrentPage(page)}
                />
            </div>

            <br /><br /><br />

            <MenuBar />
        </>
    );
}

export default OrderShow;
